import React from "react";
import GroupUser from "../../../../styles/svg/Team-group.svg";
import { Tooltip } from "@mui/material";
import { TooltipName } from "../../../../utils/Enums";
import { useGroupingStatusToggle } from "../../hooks/useGroupingStatusToggle";

function Status({ setIsVisible }) {
  const { status, toggleStatus } = useGroupingStatusToggle(setIsVisible);

  return (
    <div className="ml-3 mr-3 d-flex align-items center">
      <Tooltip
        title={
          status
            ? TooltipName.TEAM.SWITCH_TO_KANBAN_VIEW
            : TooltipName.TEAM.SWITCH_TO_ACCORDIAN_VIEW
        }>
        <label className="switch_tgl">
          <input
            type="checkbox"
            value={status}
            checked={status}
            onChange={toggleStatus}
          />
          <div
            className={`slider_tgl_att d-flex align-items-center ${
              status
                ? "status-primary-bg"
                : "justify-content-end status-secondary-bg"
            }`}
            style={{
              "--bg-img": `url(${GroupUser})`,
            }}>
          </div>
        </label>
      </Tooltip>
    </div>
  );
}

export default Status;
